
(function () {
    'use strict';

    angular.module(modules.homeModule)
        .controller(controllers.myReadingReceiptsController, myReadingReceiptsController);

    myReadingReceiptsController.$inject = ['$scope', '$http', '$state', '$uibModalInstance', 'localStorageService'];

    function myReadingReceiptsController($scope, $http, $state, $modalInstance, localStorageService) {
        var vm = this;
        vm.initialize = initialize;
        vm.translation = globalResources;
        vm.openTree = openTree;
        vm.clearSelectedFolder = clearSelectedFolder;
        vm.viewReport = viewReport;
        vm.cancel = cancel;
        vm.chooseAmongFavorites = chooseAmongFavorites;

        vm.originalFolderTree = null;
        vm.originalFavorites = null;

        var itemAll = { id: -1, name: vm.translation.All };

        function initialize() {
            vm.includeSubfolders = false;
            vm.showFolderTree = false;
            vm.selectedFolder = null;
            vm.style = {
                folderClass: '',
                inputClass: ''
            };
            var chooseAmongFavorites = localStorageService.getItem('ChooseAmongFavorites');
            if (chooseAmongFavorites == null || chooseAmongFavorites == 'false') {
                getFolderTree();
            } else {
                vm.chooseFavorite = true;
                getFolderFavorites();
            }
            vm.title = String.format(globalResources.MyReadingReceipt, user.fullName);
        };

        function openTree() {
            vm.showFolderTree = !vm.showFolderTree;
        };

        function clearSelectedFolder($event) {
            vm.selectedFolder = null;
            vm.style.folderClass = '';
            vm.style.inputClass = '';
        };

        $scope.$watch('vm.selectedFolder', function (selected) {
            if (selected) {
                if (selected.id == -1) {
                    vm.includeSubfolders = true;
                }
            }
        });

        function viewReport() {
            var id = 0, includeSubfolders = true;
            if (vm.selectedFolder.id > 0) {
                id = vm.selectedFolder.id;
                includeSubfolders = vm.includeSubfolders;
            }
            $state.go(handbookActions.MyReadingReceiptsReport, {
                folderId: id,
                recursive: includeSubfolders
            });

            $modalInstance.close();
        };

        function cancel() {
            $modalInstance.close();
        };

        $scope.selectNodeLabel = function (node) {
            vm.selectedFolder = node;
            vm.showFolderTree = false;
            vm.style.folderClass = 'mrc-folder-' + node.type;
            if (node.id > 0) {
                vm.style.inputClass = 'padding-left-65';
            } else {
                vm.style.inputClass = '';
            }
        };

        $scope.selectNodeHead = function (node) {
            //check if type of selected node is in [1, 2, 3, 4] = [Document, LinkDocument, FileDocument, ShortcutDocument] refer to enum NodeType, we dont call request
            if (!node.isLoaded && node.type > 4) {
                // Does not follow config ShowDocumentsInTree
				$http.get(handbookRequests.GetFoldersRequest, { params: { 'Id': node.id, 'showDocumentInTree': false } })
                    .success(function (data, status, headers, config) {
                        node.children = data;
                        node.isLoaded = true;
                    })
                    .error(function (data, status, headers, config) {
                        node.isLoaded = true;
                    });
            }
        };

        function getFolderFavorites() {
            if (vm.originalFavorites == null) {
                $http.get(handbookRequests.GetFavoritesRequest).
                    success(function (data, status, headers, config) {
                        var tempData = [];
                        tempData.push(itemAll);
                        if (data && data.length > 0) {
                            data.forEach(function (item) {
                                if (isFolderNode(item)) {
                                    tempData.push(item);
                                }
                            })
                        }
                        vm.documents = tempData;
                        vm.originalFavorites = tempData;
                        vm.selectedFolder = itemAll;
                    });
            } else {
                vm.documents = vm.originalFavorites;
            }
        };

        function getFolderTree() {
            if (vm.originalFolderTree == null) {
				$http.get(handbookRequests.GetFoldersRequest, { params: { 'id': null, 'showDocumentInTree': false } })
                    .success(function (data, status, headers, config) {
                        data.splice(0, 0, itemAll);
                        vm.documents = data;
                        vm.originalFolderTree = data;
                        vm.selectedFolder = itemAll;
                    });
            } else {
                vm.documents = vm.originalFolderTree;
            }
        };

        function chooseAmongFavorites() {
            if (vm.chooseFavorite) {
                getFolderFavorites();
                localStorageService.setItem('ChooseAmongFavorites', true);
            } else {
                getFolderTree();
                localStorageService.setItem('ChooseAmongFavorites', false);
            }
        };

        function isFolderNode(node) {
            return node.type == E.nodeTypes.Folder || node.type == E.nodeTypes.TopFolder || node.type == E.nodeTypes.DepartmentFolder || node.type == E.nodeTypes.RegionalFolder;
        };
    };
})();

